export type MapConfig = {
    apiKey: string,
    proximitySearch: {
        fitCutoffCountMin: number,
        fitCutoffCountMax: number,
        fitCutoffDistance: number,
        fitPadding: number,
        listCutoffCountMin: number,
        listCutoffCountMax: number,
        listCutoffDistance: number
        debug: boolean,
    },
};

const apiKey = (typeof (window as any).buggyFitGoogleMapsApiKey !== 'undefined' ? (window as any).buggyFitGoogleMapsApiKey : 'NO-MAPS-KEY') as string;

const config: MapConfig = {
    apiKey: apiKey,
    proximitySearch: {
        fitCutoffCountMin: 3, // always includes the closest X regions in viewport
        fitCutoffCountMax: 8, // at most includes the closest X regions in viewport
        fitCutoffDistance: 50000, // does not include regions with a distance more than X meters
        fitPadding: 20, // in pixels,

        listCutoffCountMin: 3, // always includes the closest X regions in list
        listCutoffCountMax: 12, // at most includes the closest X regions in list
        listCutoffDistance: 500000, // does not include regions with a distance more than X meters

        debug: false,
    },
}

export default config;
